import {motion } from 'framer-motion'

import { Link } from 'react-router-dom'
const Certificates = () => {
  return (
     
      
      <div  className="container">
      <motion.div className='about row mt-5' whileInView={{opacity:1}} transition={{staggerChildren:0.2}}>
           <motion.div initial={{ opacity:0}} whileInView={{ opacity:1,x:0 }} transition={{type: "spring",delay:0.2}} className='about-set col-lg-4 col-sm-12'>
                    <h1>about me</h1>
                    <p>i studied web development for one year from various resources , and i completed "meta front end developer professional certificate" offered by coursera.</p>
                </motion.div>
           <motion.div initial={{opacity:0  }} whileInView={{x:0, opacity:1}} transition={{type: "spring",delay:0.4}} className='about-set col-lg-4 col-sm-12'>
                    <h1>meta certificate</h1>
                    <motion.div className="link" whileHover={{scale:1.2}} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                    <Link to="about">view</Link>
                    </motion.div>
                </motion.div>
           <motion.div initial={{opacity:0 }} whileInView={{x:0 , opacity:1}} transition={{type: "spring",delay:0.6}} className='about-set col-lg-4 col-sm-12'>
                    <h1>my resume</h1>
                    <motion.div whileHover={{scale:1.2}} transition={{ type: "spring", stiffness: 400, damping: 10 }} className="link">
                    <Link to="about">view</Link>
                    </motion.div>
                </motion.div>
      </motion.div>
    </div>
      
  )
}

export default Certificates